import { render, staticRenderFns } from "./Joinlist.vue?vue&type=template&id=402236e9&scoped=true"
import script from "./Joinlist.vue?vue&type=script&lang=js"
export * from "./Joinlist.vue?vue&type=script&lang=js"
import style0 from "./Joinlist.vue?vue&type=style&index=0&id=402236e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402236e9",
  null
  
)

export default component.exports